import { Users as WorkspaceUsers } from '../administration/users';

const Users = () => <WorkspaceUsers />;

export default Users;

